
/* Audio46: accessibility for Slick product carousels. */
(function ($) {
  'use strict';

  if (!$) return;

  function syncCarousel(slider) {
    if (!slider || !slider.classList.contains('slick-initialized')) {
      return;
    }

    var section = slider.closest('[data-section-type="carousel-section"]');
    var heading = section &&
      section.querySelector('.section-header h2, .section-header h3');

    // Identify the carousel to screen readers.
    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-roledescription', 'carousel');
    slider.setAttribute(
      'aria-label',
      heading && heading.textContent.trim()
        ? heading.textContent.trim() + ' products'
        : 'Products'
    );

    // Make previous/next controls descriptive.
    slider.querySelectorAll('.slick-arrow').forEach(function (arrow) {
      if (arrow.classList.contains('slick-prev')) {
        arrow.setAttribute('aria-label', 'Previous products');
      } else if (arrow.classList.contains('slick-next')) {
        arrow.setAttribute('aria-label', 'Next products');
      }
    });

    slider.querySelectorAll('.slick-slide').forEach(function (slide) {
      var visible =
        slide.classList.contains('slick-active') &&
        !slide.classList.contains('slick-cloned');

      // Off-screen slides and clones must not receive keyboard focus.
      if (visible) {
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('inert', '');
      }

      slide.setAttribute('aria-hidden', visible ? 'false' : 'true');

      // The product card itself doesn't need an extra Tab stop.
      slide.removeAttribute('tabindex');

      // Image and title link to the same product.
      // Keep image mouse-clickable but remove its redundant Tab stop.
      var imageLink = slide.querySelector(
        '.grid-view_image > a.grid-view-item__link'
      );

      if (imageLink) {
        imageLink.setAttribute('tabindex', '-1');
        imageLink.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function scheduleSync(slider) {
    window.requestAnimationFrame(function () {
      syncCarousel(slider);
    });
  }

  // Slick updates accessibility attributes during slide transitions.
  // Apply our rules after its updates finish.
  $(document).on(
    'init reInit afterChange setPosition breakpoint',
    '.productSlider',
    function () {
      scheduleSync(this);
    }
  );

  function scanCarousels() {
    document.querySelectorAll(
      '.productSlider.slick-initialized'
    ).forEach(syncCarousel);
  }

  // Handle any carousels initialized before this script runs.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCarousels);
  } else {
    scanCarousels();
  }

  // Handle sections reloaded by Shopify's theme editor.
  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(scanCarousels);
  });

})(window.jQuery);
